module.exports = __webpack_public_path__ + "static/img/heroimage_new_large.8a33598.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_new_large.png
// module id = 176
// module chunks = 1